// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"LjSpinner-module_spinnerContainer_2ed6c","overlay":"LjSpinner-module_overlay_95297","spinner":"LjSpinner-module_spinner_ac964"};